import React, { createContext, useState } from "react";

export const CartContext = createContext(null);
const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const addToCart = (item, callback) => {
    setCart([...cart, item]);
    setTimeout(callback(), 100);
  };

  const updateItem = (id, count, price, callback) => {
    setCart((prevItems) => {
      prevItems.forEach((item) => {
        if (id === item.part_number) {
          item["count"] = count;
          item["totalPrice"] = price;
        }
      });
      return [...prevItems];
    });
    setTimeout(callback(), 100);
  };

  const value = { addToCart, cart, updateItem };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartProvider;
